export default __webpack_public_path__ + "static/media/mobile-2.1b00c49c.png";